import { useRef } from "react";

/**
 * Último valor NO nulo recibido · para modales cuyo `open` depende de que el dato exista
 * (`open={dato !== null}`): al cerrar, el dato pasa a null de inmediato pero el modal aún
 * hace su animación de salida; con esto sigue mostrando el contenido anterior en vez de
 * vaciarse (se encogía y parpadeaba al desaparecer).
 */
export function useUltimoNoNulo<T>(valor: T | null): T | null {
  const ultimo = useRef<T | null>(valor);
  if (valor !== null) ultimo.current = valor;
  return valor ?? ultimo.current;
}
